module.exports = __webpack_public_path__ + "static/1-33d43185163be08b31727c5f436c6004.svg";